import { useState, useEffect } from 'react';
import axios from 'axios';

import { API_URL } from './houseHelpers';

export const useSensorDictionaries = () => {
    const [temperatureSensors, setTemperatureSensors] = useState([]);
    const [pressureSensors, setPressureSensors] = useState([]);
    const [flowMeters, setFlowMeters] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const loadDictionaries = async () => {
            setLoading(true);

            try {
                const token = localStorage.getItem('token');

                const headers = {
                    Authorization: `Bearer ${token}`
                };

                const [tempRes, pressRes, flowRes] = await Promise.all([
                    axios.get(`${API_URL}/api/sensor-dictionaries?type=1`, { headers }),
                    axios.get(`${API_URL}/api/sensor-dictionaries?type=2`, { headers }),
                    axios.get(`${API_URL}/api/sensor-dictionaries?type=3`, { headers })
                ]);

                setTemperatureSensors(tempRes.data || []);
                setPressureSensors(pressRes.data || []);
                setFlowMeters(flowRes.data || []);
            } catch (err) {
                console.error('Ошибка загрузки справочников:', err);
            } finally {
                setLoading(false);
            }
        };

        loadDictionaries();
    }, []);

    return {
        temperatureSensors,
        pressureSensors,
        flowMeters,
        loading
    };
};